<template>
    <div class="setting-form-wrap">
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                注册地区：
                <span class="is-required">*</span>
            </div>
            <el-select
                v-model="formData.region"
                :filterable="true"
                size="large"
            >
                <el-option-group
                    v-for="group in regionDatasource"
                    :key="group.label"
                    :label="group.label"
                >
                    <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-option-group>
            </el-select>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                纳税人类型：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content setting-checkbox-wrap">
                <button
                    v-for="(item, index) in taxpayerTypeDataSource"
                    :key="index"
                    :class="{active: formData.taxpayerType === item.value}"
                    @click="onChangeFormDate('taxpayerType', item.value)"
                >{{ item.label }}</button>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                年开票额：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content setting-checkbox-wrap">
                <button
                    v-for="(item, index) in invoiceAmountDataSource"
                    :key="index"
                    :class="{active: formData.invoiceAmount === item.value}"
                    @click="onChangeFormDate('invoiceAmount', item.value)"
                >{{ item.label }}</button>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                服务时长：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content setting-checkbox-wrap">
                <button
                    v-for="(item, index) in yearDatasource"
                    :key="index"
                    :class="{active: formData.serviceTime === item.value}"
                >{{ item.text }}</button>
            </div>
        </div>
    </div>
</template>

<script>

import {
    taxpayerTypeDataSource,
    invoiceAmountDataSource,
    yearDatasource
} from '../../pages/data/bkp';
import {regionMixin} from './mixin';

export default {
    mixins: [regionMixin],

    data() {
        return {
            formData: {
                stepStart: 2,
                region: 110100,
                taxpayerType: 'SMALL_SCALE_TAXPAYER',
                invoiceAmount: 'ZERO',
                serviceTime: 1
            },
            regionDatasource: [],
            taxpayerTypeDataSource,
            invoiceAmountDataSource,
            yearDatasource
        };
    },

    async created() {
        await this.getRegion();
        const {bkpCities} = this.staticRegionData;
        this.regionDatasource = this.convertRegionDataToGroupData(bkpCities);
    },

    methods: {
        onChangeFormDate(type, value) {
            this.formData[type] = value;
        },

        getFormData() {
            return this.formData;
        }
    }
};
</script>

<style lang="less">
</style>